<h2 class="text-xl font-bold">
  Material
  {{mode === 'add' ? 'hinzufügen' : 'bearbeiten'}}
</h2>
<hr />
<form class="w-full" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-col w-full">
    <div class="flex flex-col mt-2">
      <label class="soft-label top required">Artikelnummer</label>
      <soft-value-converter formControlName="artikel" [converter]="artstammConverter">
        <soft-field-ok fieldOkName="artstamm"
                       [readonly]="mode === 'edit'"
                       [parameters]="{kzartikelart: '!ARB'}"
                       softFocus
                       #convertValue>
        </soft-field-ok>
      </soft-value-converter>
    </div>
    <div class="flex flex-col mt-2">
      <label class="soft-label top" [class.required]="!templateValues || (templateValues && templateValues.legierungspflichtig === true)">Legierung</label>
      <soft-value-converter formControlName="legierung" [converter]="chargeConverter">
        <soft-field-ok fieldOkName="charge"
                       [tabindex]="(templateValues && (templateValues?.legierungspflichtig === false || templateValues?.legierungspflicht === false)) ? -1 : 0"
                       [readonly]="(templateValues && (templateValues?.legierungspflichtig === false || templateValues?.legierungspflicht === false)) || false"
                       #convertValue>
        </soft-field-ok>
      </soft-value-converter>
    </div>
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top">Carat</label>
      <soft-number-input formControlName="mengeCt"
                         #inputCarat
                         (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); inputCarat.onBlur(inputCarat.input)"
                         [readonly]="templateValues?.carateingabe === true ? false : true"
                         [tabindex]="templateValues?.carateingabe ? 0 : -1">
      </soft-number-input>
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top">Gramm</label>
    <soft-number-input formControlName="mengeGramm"
                       #inputGramm
                       (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); inputGramm.onBlur(inputGramm.input)"
                       [readonly]="templateValues?.carateingabe === true ? false : true"
                       [tabindex]="templateValues?.carateingabe ? 0 : -1">
    </soft-number-input>
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top required">Menge</label>
      <soft-number-input formControlName="menge" (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); input.onBlur(input.input)" #input></soft-number-input>
      <!-- <soft-number-input class="w-1/2" formControlName="mengeCt" (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); input.onBlur(input.input)"></soft-number-input> -->
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top required">Einheit</label>
    <soft-value-converter formControlName="arteh" [converter]="artehConverter">
      <soft-field-ok fieldOkName="arteh"
                     [parameters]="{ idartstamm: $safeNavigationMigration(form.value['artikel']?.id) }"
                     #convertValue>
      </soft-field-ok>
    </soft-value-converter>
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top required">Gewicht</label>
    <soft-number-input formControlName="gewicht"></soft-number-input>
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top">Aufschlag Verkauf (Prozent)</label>
    <div class="flex gap-2 w-full items-center">
      <soft-number-input formControlName="aufschlagArtikelgruppe" class="w-full"></soft-number-input>
      <span class="text-right font-semibold">%</span>
    </div>
  </div>
  <button type="submit"
          class="soft-button primary w-full h-12 mt-4"
          [disabled]="form.invalid">
    Speichern
  </button>
</form>
